const sections = [
  {
    id: 0,
    name: 'Configuración',
    key: ['SETTINGS', 'DOORS', 'ROLE', 'PERMITS'],
    img: 'SKLB-Configuracion.png',
  },
  {
    id: 1,
    name: 'Niveles',
    key: ['LEVELS', 'GG'],
    img: 'SKLB-Niveles.png',
  },
  {
    id: 14,
    name: 'Subgrupos',
    key: 'SUBGROUPS',
    img: 'SKLB-Grupos.png',
  },
  {
    id: 10,
    name: 'Extracurriculares',
    key: ['EXTRAS'],
    img: 'SKLB-Registros.png',
  },
  {
    id: 2,
    name: 'Colaboradores',
    key: 'COLAB',
    img: 'SKLB-Colabordores.png',
  },
  {
    id: 3,
    name: 'Alumnos',
    key: ['STUDENTS'],
    img: 'SKLB-Alumnos.png',
  },
  {
    id: 4,
    name: 'Tutores',
    key: ['PARENTS', 'CARS', 'QR', 'STUDENT'],
    img: 'SKLB-Tutores.png',
  },
  {
    id: 5,
    name: 'Rondas',
    key: ['ROUNDS'],
    img: 'SKLB-Ronda.png',
  },
  {
    id: 6,
    name: 'Dispositivos',
    key: ['DEVICES', 'UD', 'IPAD'],
    img: 'SKLB-Dispositivos.png',
  },
  {
    id: 7,
    name: 'Comunidad',
    key: 'NOTICE',
    img: 'SKLB-Comunidad.png',
  },
  {
    id: 8,
    name: 'Estadísticas',
    key: 'STATS',
    img: 'SKLB-Estadisticas.png',
  },
  {
    id: 9,
    name: 'Salidas',
    key: 'VISOR',
    img: 'SKLB-Entregas.png',
  },
  // {
  //   id: 11,
  //   name: "Payments",
  //   nombre: "Pagos",
  //   key: "PAYMENTS",
  //   img: "SKLB-Pagos.png"
  // },
  {
    id: 12,
    name: 'Encuestas',
    key: 'POLLS',
    img: 'SKLB-Encuestas.png',
  },
  {
    id: 13,
    name: 'Citas',
    key: 'VISITS',
    img: 'SKLB-Citas.png',
  },
  {
    id: 15,
    name: 'Entradas',
    key: 'ENTRIES',
    img: 'SKLB-Entries.png',
  },
  {
    id: 16,
    name: 'Reportes',
    key: 'REPORTS',
    img: 'SKLB-Reportes.png',
  },
  // {
  //   id: 17,
  //   name: 'Help',
  //   key: 'HELP',
  //   img: 'SKLB-Help.png',
  // },
  {
    id: 18,
    name: 'Horarios de colaboradores',
    nombre: 'Horarios de colaboradores',
    key: 'SCHEDULE',
    img: 'SKLB-HorarioColab.png',
  },
  {
    id: 19,
    name: 'Transporte escolar',
    nombre: 'Transporte escolar',
    key: 'TRANSPORT',
    img: 'bus.png',
  },
]

export { sections }
